<div class="label-section">
  @if (!isLabelHidden && label) {
    <label [id]="labelId" [for]="fieldId" [class.no-description]="!description">
      {{ label }}
      @if (isRequired()) {
        <span>*</span>
      }
    </label>
  }

  <ng-content
    select="mr-link[mrFieldLabelAction],mr-button[mrFieldLabelAction]"
  ></ng-content>

  @if (!isLabelHidden && description) {
    <span [id]="descriptionId" class="description">{{ description }}</span>
  }
</div>

<ng-content></ng-content>

@if (!areErrorsHidden && getErrors(); as errors) {
  <ul>
    @if (errors["email"]) {
      <li>{{ errorLabel }} must be a valid email address</li>
    }
    @if (errors["digits"]) {
      <li>{{ errorLabel }} must contain only the numerical digits 0&ndash;9</li>
    }
    @if (errors["max"]; as error) {
      <li>{{ errorLabel }} must be less than or equal to {{ error.max }}</li>
    }
    @if (errors["maxlength"]; as error) {
      <li>
        {{ errorLabel }} must be at most
        {{ error.requiredLength | amount: "character" }} long
      </li>
    }
    @if (errors["min"]; as error) {
      <li>{{ errorLabel }} must be greater than or equal to {{ error.min }}</li>
    }
    @if (errors["minlength"]; as error) {
      <li>
        {{ errorLabel }} must be at least
        {{ error.requiredLength | amount: "character" }} long
      </li>
    }
    @if (errors["minuteStep"]; as error) {
      <li>
        {{ errorLabel }} must be an increment of
        {{ error.step | amount: "minute" }}
      </li>
    }
    @if (errors["required"]) {
      <li>{{ errorLabel }} is required</li>
    }
    @if (errors["step"]; as error) {
      <li>{{ errorLabel }} must be an increment of {{ error.step }}</li>
    }
    @if (errors["unique"]; as error) {
      <li>{{ errorLabel }} of "{{ error.match }}" already exists</li>
    }
    @if (errors["maxArrayLength"]; as error) {
      <li>
        {{ errorLabel }} must include no more than
        {{ error.max | amount: "item" }}
      </li>
    }
    @if (errors["isOccupied"]; as error) {
      <li>{{ errorLabel }} is occupied</li>
    }
    <ng-container
      [ngTemplateOutlet]="additionalErrorMessageTemplate || null"
      [ngTemplateOutletContext]="{ $implicit: errors, errorLabel: errorLabel }"
    ></ng-container>
  </ul>
}
